import { schema } from 'normalizr';

const users = new schema.Entity('users', {}, { idAttribute: 'id' });
const usersSchema = [users];

export default usersSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/usersSchema.js